/* @flow */

import React from 'react';
import { Table, Label, Button } from 'semantic-ui-react';

type Props = {
  target: Target,
  isEditable: boolean,
  roles: Array<UserRole>,
  onDelete: () => void,
};

function TargetRole({ target, roles }) {
  const role = roles.find(r => r.code === target.role);
  if (role) {
    return <Label color="green">{role.label}</Label>;
  } else {
    return <Label>Tous les rôles</Label>;
  }
}

function TargetTags({ target }) {
  if (target.tags && target.tags.length) {
    return (
      <span>
        {target.tags.map(t => <Label key={t}>{t}</Label>)}
      </span>
    );
  }

  return <Label>Tous les tags</Label>;
}

const DiffusionTarget = ({ target, onDelete, isEditable, roles }: Props) => {
  const remove = () => onDelete(target);

  return (
    <Table.Row>
      {isEditable &&
        <Table.Cell collapsing>
          <Button
            type="button"
            size="tiny"
            color="red"
            icon="remove"
            onClick={remove}
          />
        </Table.Cell>}
      <Table.Cell textAlign="center">
        <TargetRole target={target} roles={roles} />
      </Table.Cell>
      <Table.Cell textAlign="center">
        <TargetTags target={target} />
      </Table.Cell>
    </Table.Row>
  );
};

export default DiffusionTarget;



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/DiffusionTarget.js